<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('label-list')">Labels</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-6xl">

      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <text-input v-model="form.label_name" :error="form.errors.label_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Label Name" required />
            <select-input v-if="$page.props.auth.user.customer_id == 0" v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Customer" required >
              <option :value="null" />
              <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
            </select-input>
            <text-input v-if="$page.props.auth.user.owner" v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-1/2" label="Label Description" />
            <text-input v-if="$page.props.auth.user.owner" v-model="form.prod_no_cerm" :error="form.errors.prod_no_cerm" class="pr-6 pb-8 w-full lg:w-1/2" label="Production No CERM" type="number" required />
            <text-input v-if="$page.props.auth.user.owner" v-model="form.ref_cacl_cerm" :error="form.errors.ref_cacl_cerm" class="pr-6 pb-8 w-full lg:w-1/2" label="Reference Calc CERM" type="number" required />
            <text-input v-if="$page.props.auth.user.owner" v-model="form.price_per_1k" :error="form.errors.price_per_1k" class="pr-6 pb-8 w-full lg:w-1/2" label="Price Per Unit (EURO)" type="number" step="0.0001" required />
            <text-input v-if="$page.props.auth.user.owner" v-model="form.unit" :error="form.errors.unit" class="pr-6 pb-8 w-full lg:w-1/2" label="Quantity Unit" type="number" required />

            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <input type="file" @input="form.label_file = $event.target.files[0]" required />
              <progress v-if="form.progress" :value="form.progress.percentage" max="100">
                {{ form.progress.percentage }}%
              </progress>
            </div>

           <div v-if="$page.props.auth.user.owner" class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <input type="file" @input="form.thumbnail_path = $event.target.files[0]" required />
              <progress v-if="form.progress" :value="form.progress.percentage" max="100">
                {{ form.progress.percentage }}%
              </progress>
            </div>

          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Label</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create Label' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
  },
  layout: Layout,
  props: {
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        label_name: null,
        description: null,
        organization_id: null,
        prod_no_cerm: null,
        ref_cacl_cerm: null,
        price_per_1k: null,
        unit: null,
        label_file: null,
        thumbnail_path: null,
      }),
    }
  },
mounted(){
  // console.log(this.organizations)
},
  methods: {
    store() {
      // console.log(this.form);
      if(this.form.organization_id == null && this.$page.props.auth.user.customer_id > 0){
        this.form.organization_id =  this.$page.props.auth.user.customer_id
        this.form.ref_cacl_cerm = 0
        this.form.prod_no_cerm = 0
        this.price_per_1k = 0
        this.form.thumbnail_path = ''
      }
      if(this.form.label_file['type'] !== 'application/pdf'){
        alert('Please provide pdf file for label')
      }else if(this.form.thumbnail_path['type'] !== 'image/jpg' && this.form.thumbnail_path['type'] !== 'image/jpeg' && 
      this.form.thumbnail_path['type'] !== 'image/png' && this.form.thumbnail_path['type'] !== 'image/svg+xml' && this.form.thumbnail_path['type'] !== 'image/jpg2' &&  this.$page.props.auth.user.owner){
        alert('Please provide image file for label thumbnail')
      }else{
          this.form.post('/new-label')
      }

    }
  },
}
</script>
